import React from 'react'
import { useTranslation } from 'react-i18next'

function LanguageSwitcher() {
  const { i18n, t } = useTranslation()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
    localStorage.setItem('language', lng)
  }

  return (
    <div
      className="flex items-center gap-2 bg-white/20 rounded-lg p-1"
      role="group"
      aria-label={t('accessibility.languageSelector', 'Language selector')}
    >
      <button
        onClick={() => changeLanguage('de')}
        className={`px-3 py-1 rounded font-semibold text-sm transition-all ${
          i18n.language === 'de'
            ? 'bg-white text-indigo-600 shadow'
            : 'text-white hover:bg-white/10'
        }`}
        aria-label={t('accessibility.switchToGerman', 'Switch to German')}
        aria-pressed={i18n.language === 'de'}
      >
        DE
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded font-semibold text-sm transition-all ${
          i18n.language === 'en'
            ? 'bg-white text-indigo-600 shadow'
            : 'text-white hover:bg-white/10'
        }`}
        aria-label={t('accessibility.switchToEnglish', 'Switch to English')}
        aria-pressed={i18n.language === 'en'}
      >
        EN
      </button>
    </div>
  )
}

export default LanguageSwitcher
